<mat-card class="barrier-card">
    <mat-card-header>
        <mat-card-title>{{ barrier.deviceName || 'Barrier' }}</mat-card-title>
        <mat-card-subtitle>{{ barrier.deviceStatus || 'Unknown' }}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        <div class="barrier-info">
            <div class="info-row">
                <strong>Hardware ID:</strong>
                <span>{{ barrier.deviceHardwareID || '-' }}</span>
            </div>
            <div class="info-row">
                <strong>Description:</strong>
                <span>{{ barrier.deviceDescription || '-' }}</span>
            </div>
            <div class="info-row">
                <strong>Base URL:</strong>
                <span>{{ barrier.config?.baseUrl || '-' }}</span>
            </div>
            <div class="info-row">
                <strong>Open Path:</strong>
                <span>{{ barrier.config?.openPath || '-' }}</span>
            </div>
            <div class="info-row">
                <strong>Close Path:</strong>
                <span>{{ barrier.config?.closePath || '-' }}</span>
            </div>
            <div class="info-row">
                <strong>Open Pulse Path:</strong>
                <span>{{ barrier.config?.openPulsePath || '-' }}</span>
            </div>
            <div class="info-row">
                <strong>Toggle Relay Path:</strong>
                <span>{{ barrier.config?.toggleRelayPath || '-' }}</span>
            </div>
            <div class="info-row">
                <strong>Master Controller:</strong>
                <span>{{ barrier.masterControllerId || '-' }}</span>
            </div>
        </div>

        <app-zone-barrier-commands [barrierId]="barrier.id || null"></app-zone-barrier-commands>
    </mat-card-content>

    <mat-card-actions class="card-actions">
        <button mat-raised-button color="primary" (click)="onEdit()" [disabled]="isProcessing">
            <mat-icon>edit</mat-icon>
            Edit Barrier
        </button>
        <button mat-stroked-button color="accent" (click)="onUnassign()" [disabled]="isProcessing">
            <mat-icon>link_off</mat-icon>
            Unassign
        </button>
        <button mat-stroked-button color="warn" (click)="onDelete()" [disabled]="isProcessing">
            <mat-icon>delete</mat-icon>
            Remove Barrier
        </button>
    </mat-card-actions>
</mat-card>